import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, LogOut } from 'lucide-react';
import UserContext from '../../../context/UserContext/UserContext';
import AuthService from '../../../services/AuthService/AuthService';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '../../ui/dropdown-menu';
import { Avatar, AvatarFallback } from '../../ui/avatar';

function UserDropdown(): React.ReactElement {
  const { user, setUser } = React.useContext(UserContext);
  const navigate = useNavigate();

  const getUserInitials = (): string => {
    if (user) {
      return `${user.firstName[0]}${user.lastName ? user.lastName[0] : ''}`;
    }
    return '';
  };

  const handleLogout = (): void => {
    AuthService.logoutAndClearToken().finally(() => {
      setUser(null);
      navigate('/login');
    });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type='button'
          className='relative h-8 w-8 rounded-full hover:bg-white/10 transition-colors'
        >
          <Avatar className='h-8 w-8'>
            <AvatarFallback className='bg-white/20 text-white font-medium'>
              {getUserInitials()}
            </AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='w-64' align='end'>
        <DropdownMenuLabel className='font-normal'>
          <div className='flex flex-col space-y-1'>
            <p className='text-base font-medium leading-none'>
              {user?.firstName} {user?.lastName}
            </p>
            <p className='text-sm leading-none text-muted-foreground'>
              {user?.email}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className='cursor-pointer'
          onClick={() => navigate('/profile')}
        >
          <User className='mr-2 h-5 w-5' />
          <span>Manage profile</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem className='cursor-pointer' onClick={handleLogout}>
          <LogOut className='mr-2 h-5 w-5' />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default UserDropdown;
